module.exports = __webpack_public_path__ + "static/img/jiqi-txt5.b614634.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt5.png
// module id = WaSz
// module chunks = 0